<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3L10.07 19.97L12.58 12.58L19.97 10.07L3 3Z" fill="white" stroke="#21272A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13 13L19 19" stroke="#21272A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
